module.exports = __webpack_public_path__ + "img/whiteboardIcon.14a44252.svg";